/**
 * 检查指定的功能是否在禁用列表中
 * @param feature - 需要检查的功能名称
 * @returns 如果在禁用列表中返回 true,否则返回 false
 */
export const inDisableList = (feature: string): boolean => {
  const disableList = window.fl?.preconfig?.disableList || []
  return disableList.includes(feature)
}
